
export default {
    name: "FloatingChatButton",
    props: {
        /** If the activator button should be in fixed position */
        fixed: {
            type: Boolean,
            default: false,
        },
        numberOfUnreadMessages: {
            type: Number,
            default: 0,
        },
    },
}
